import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { TypeStyle } from '../TypeStyle';
export const OpenVideoIcon = styled.div `
  background: ${o => o.theme.color.button.primary.fill.on.background};
  border-radius: 50%;
  box-shadow: 0 0 10px -5px ${o => o.theme.color.button.primary.content.on.background};
  height: 24px;
  min-width: 24px;
  position: relative;
  width: fit-content;

  &::after {
    content: '';
    display: block;
    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 8px solid ${o => o.theme.color.button.primary.content.on.background};
    height: 0;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-36%, -50%);
    width: 0;
  }
`;
export const OpenVideoText = styled.span `
  ${TypeStyle.css.eyebrow}
  color: ${o => o.theme.color.text.primary.on.background};
  border-bottom: 1px solid ${o => o.theme.color.text.primary.on.background};
  padding-bottom: 2px;
`;
export const OpenVideoTextButton = styled.button `
  display: inline-flex;
  gap: 10px;
  align-items: center;
  max-height: 46px;
  width: fit-content;
  &:hover {
    > ${OpenVideoIcon} {
      background: ${o => o.theme.color.stroke.neutral.text.secondary.on.background};
    }
  }
`;
export const OpenVideoModalTextButton = ({ text, onClick, ...buttonPassthroughProps }) => {
    return (_jsxs(OpenVideoTextButton, { type: 'button', onClick: onClick, ...buttonPassthroughProps, children: [_jsx(OpenVideoIcon, {}), _jsx(OpenVideoText, { children: text })] }));
};
//# sourceMappingURL=index.js.map